import { render } from "./ConfirmationDeleteDialog.vue?vue&type=template&id=33f3a404&scoped=true&ts=true"
import script from "./ConfirmationDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDeleteDialog.vue?vue&type=script&lang=ts"

import "./ConfirmationDeleteDialog.vue?vue&type=style&index=0&id=33f3a404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f3a404"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QInput,QBtn});
